module.exports = __webpack_public_path__ + "img/scroll-down-arrow-icon.017951bf.svg";